import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import Content from "../../../components/Export/Content";
import Column from "../../../components/Export/Column";
import Table from "../../../components/Export/Table";
import Table2 from "../../../components/Export/Table2";
import Row from "../../../components/Export/Row";

import "./ReceptBillSummary.css";
import Spinner from "../../../components/UI/Spinner/Spinner";
import Filter from "../../../helpers/Filter";
import Axios from "axios";
import NoData from "../../../components/UI/Spinner/NoData";
import Configs from "../../../Configs";

const styleRow = {};

const WASTE = "Wastage";

const styleRowTotal = {
  borderBottom: "2px solid #f4f4f4",
  borderTop: "2px solid #f4f4f4",
};

const title = {
  SALE_TYPE: "Sale Type",
  CONTROLLER: "Controller",
  CREATE: "Create",
  MODIFY: "Modify",
  MASTER_KEY_ID: "Master Item ID",
  NAME_OF_ITEM: "Name of Item",
  STATUS: "Status",
  PREPARE_STATION: "Prepare Station",
  QUANTITY: "Quantity",
  UNIT_SELLING_PRICE: "Unit Selling Price",
  ITEM_SALES: "Item Sales",
  PRICE_NAME: "Price Name",
  PAYMENT_TYPE: "Payment Type",
  ORDER_NO: "Order No",
  TABLE_NO: "Table No",
  WAITER: "Waiter",
  AGENT: "Agent",
  MEMBERSHIP_ID: "Membership ID",
  MEMBER_NOTE: "Member Note",
  BILL_DISCOUNT_PERCENT: "Bill Discount (%)",
  BILL_DISCOUNT_NOTE: "Bill Discount (Note)",
  UNIT_ORIGINAL_PRICE: "Unit Original Price",
  UNIT_PRICE_AFTER_ITEM_DISC: "Unit Price After Item Disc",
  COMMENT: "Comment",
  REOPEN_BILL: "Reopen Bill",
  NO_OF_COPY_BILL_PRINT: "No. of Copy Bill Print",
  CATEGORY: "Category",
  CATEGORY_SUB: "Category Sub",
  PROMOTION: "Promotion",
  COMPLIMENTARY_BY: "Complimentary by",
  SHIFT: "Shift",
  ORIGINAL_ORDER_NO: "Original Order No",
  TOTAL_UNIT_DISCOUNT: "Total Unit Discount",
  UNIT_DISCOUNT: "Unit Discount",
  UNIT_DISCOUNT_PERCENT: "Unit Discount(%)",
  NO_OF_REOPEN_BILL: "No. of Reopen Bill",
  BILL_DISCOUNT: "Bill Discount",
  ITEM_BILL_DISCOUNT: "Item (Bill Discount)",
  TOTAL_NET_PRICE: "Total Net Price",
  NAME_OF_TAX_1: "Name of Tax 1",
  TAX_1_PERCENT: "Tax 1 (%)",
  NAME_OF_TAX_2: "Name of Tax 2",
  TAX_2_PERCENT: "Tax 2 (%)",
  TAX_BEFORE_NAME: "Name of Tax Before",
  NAME_OF_TAX_BEFORE: "Name of Tax Before",
  TAX_BEFORE_PERCENT: "Tax Before(%)",
  TAX_BEFORE: "Tax Before",
  TAX_BEFORE_BILL_DISCOUNT: "Tax Before (Bill Discount)",
  TAX_BEFORE_AFTER_BILL_DISCOUNT: "Tax Before (After Bill Discount)",
  NET_TAX_BEFORE: Filter.changeToNameSettingsByOwner(
    "netTaxBeforeDiscount",
    "Net Tax Before Discount",
    false
  ),
  SUB_TOTAL: "Sub Total",
  TAX_1: Filter.changeToNameSettingsByOwner("tax1", "Tax 1", false),
  TAX_2: Filter.changeToNameSettingsByOwner("tax2", "Tax 2", false),
  GROSS: "Gross",
  TRANSACTION_ID: "Transaction ID",
  ITEM_GROSS_SALES: "Item Gross Sales",
  UNIT_CHANGE: "Unit Change",
  PAID_DEVICE_ID: "Paid Device ID",
  ORDER_DEVICE_ID: "Order Device ID",
  CANCEL_DEVICE_ID: "Cancel Device ID",
  CANCEL_BY: "Cancel by",
  PAYMENT_NOTE: "Payment Note",
  TAX_TYPE: "Tax Type",
  TOTAL_DISCOUNT: "Total Discount",
  TAX_1_TAXABLE_AMT:
    Filter.changeToNameSettingsByOwner("tax1", "Tax 1", false) +
    "(Taxable Amt*)",
  TAX_2_TAXABLE_AMT:
    Filter.changeToNameSettingsByOwner("tax2", "Tax 2", false) +
    "(Taxable Amt*)",
  TAX_BEFORE_TAXABLE_AMT: "Tax Before(Taxable Amt)",
  TOTAL_ORIGINAL_PRICE: "Total Original Price",
  UNIT_DISCOUNT_NOTE: "Unit Discount Note",
  CONTROLLER_NAME: "Controller Name",
  BILL_NO_COPY: "No. of Copy Bill Print",
  MEAL_TIME: "MealTime",
  PARENT: "Parent",
  PERIOD: "Period",
  MEMBER_ITEM: "Member Item Note",
  CANCEL_NOTE: "Cancel Note",
  SPECIAL_NOTE: "Special Note",
};

class ItemsImportSummary extends React.PureComponent {
  state = {
    reports: [],
    analysis: {},
    loading: false,
    isNotExist: false,
  };

  componentDidMount() {
    this.setState({
      loading: true,
    });
    Axios.get(`${this.props.file}`)
      .then((res) => {
        this.setState({
          analysis: res.data,
          loading: false,
          isNotExist: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          isNotExist: true,
        });
      });
  }

  exportPdf = () => {
    let view = document.getElementById("exportReceptBill").innerHTML;
    let popupWinindow = window.open(
      "",
      "_blank",
      "width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
    );
    popupWinindow.document.open();
    popupWinindow.document.write(
      '<html><head><link rel="stylesheet" type="text/css" href="' +
        Configs.abossUrl +
        '/assets/css/bootstrap.min.css" /></head><body onload="window.print()">' +
        view +
        "</html>"
    );
    popupWinindow.document.close();
  };

  calculateRoundValue = (value, numOfDecimalPlace, showLessValue) => {
    var partOne = 0;
    var demValue = "1";
    for (var d = 0; d < numOfDecimalPlace; d++) {
      demValue = demValue.toString() + "0".toString();
    }
    demValue = Number(demValue);
    if (value != 0 && value != undefined) {
      partOne = Math.round(value * demValue) / demValue;
    }
    if (showLessValue) {
      partOne = partOne * -1;
    }
    return Filter.displayCurrency(partOne);
  };

  setPrepareStationTable = (
    results,
    prepareStationNames,
    payType,
    tableTitle,
    period
  ) => {
    let values = [];
    let totalQty = 0;
    let totalGross = 0;
    let totalBillDiscount = 0;
    let totalPrice = 0;
    const prepareStationNamesLenght = prepareStationNames.length;
    for (var m = 0; m < prepareStationNamesLenght; m++) {
      const prepareStation = prepareStationNames[m];
      let quantity =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.PREPARE_STATION +
            "_" +
            prepareStation +
            "_" +
            payType +
            "_" +
            title.QUANTITY
        ];
      let gross =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.PREPARE_STATION +
            "_" +
            prepareStation +
            "_" +
            payType +
            "_" +
            title.ITEM_GROSS_SALES
        ];
      let billDiscount =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.PREPARE_STATION +
            "_" +
            prepareStation +
            "_" +
            payType +
            "_" +
            title.ITEM_BILL_DISCOUNT
        ];
      let price =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.PREPARE_STATION +
            "_" +
            prepareStation +
            "_" +
            payType +
            "_" +
            title.ITEM_SALES
        ];
      if (quantity === undefined || quantity === NaN) {
        quantity = 0;
      }
      if (gross === undefined || gross === NaN) {
        gross = 0;
      }
      if (billDiscount === undefined || billDiscount === NaN) {
        billDiscount = 0;
      }
      if (price === undefined || price === NaN) {
        price = 0;
      }

      if (quantity !== undefined) {
        values.push({
          name: prepareStation,
          val: [
            Filter.displayNumber(quantity),
            Filter.displayCurrency(gross),
            Filter.displayCurrency(billDiscount),
            Filter.displayCurrency(price),
          ],
        });
        totalQty = Number(totalQty) + Number(quantity);
        totalGross = Number(totalGross) + Number(gross);
        totalBillDiscount = Number(totalBillDiscount) + Number(billDiscount);
        totalPrice = Number(totalPrice) + Number(price);
      }
    }
    if (values.length <= 0) {
      return (
        <Table2 title={tableTitle} subTitle="(PAID)">
          <tr>
            <td colSpan="5">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: [
        Filter.displayNumber(totalQty),
        Filter.displayCurrency(totalGross),
        Filter.displayCurrency(totalBillDiscount),
        Filter.displayCurrency(totalPrice),
      ],
    });

    return (
      <Table2 title={tableTitle} subTitle="(PAID)">
        <Row
          styleRow={styleRowTotal}
          name={""}
          values={[
            "Quantity",
            "Item Gross Sales",
            "Item Bill Discount",
            "Item Sales",
          ]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setCategoryTable = (results, categoryNames, payType, tableTitle, period) => {
    let values = [];
    let totalQty = 0;
    let totalPrice = 0;
    const categoryNamesLength = categoryNames.length;
    for (var m = 0; m < categoryNamesLength; m++) {
      const categoryName = categoryNames[m];
      let quantity =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.CATEGORY +
            "_" +
            categoryName +
            "_" +
            payType +
            "_" +
            title.QUANTITY
        ];
      let price =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.CATEGORY +
            "_" +
            categoryName +
            "_" +
            payType +
            "_" +
            title.ITEM_SALES
        ];
      if (quantity === undefined || quantity === NaN) {
        quantity = 0;
      }
      if (price === undefined || price === NaN) {
        price = 0;
      }

      if (quantity !== undefined) {
        values.push({
          name: categoryName,
          val: [Filter.displayNumber(quantity), Filter.displayCurrency(price)],
        });
        totalQty = Number(totalQty) + Number(quantity);
        totalPrice = Number(totalPrice) + Number(price);
      }
    }
    if (values.length <= 0) {
      return (
        <Table2 title={tableTitle} subTitle="(PAID)">
          <tr>
            <td colSpan="3">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: [Filter.displayNumber(totalQty), Filter.displayCurrency(totalPrice)],
    });

    return (
      <Table2 title={tableTitle} subTitle="(PAID)">
        <Row
          styleRow={styleRowTotal}
          name={""}
          values={["Quantity", "Item Sales"]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setPromotionTable = (
    results,
    promotionNames,
    payType,
    tableTitle,
    period
  ) => {
    let values = [];
    let totalQty = 0;
    let totalPrice = 0;
    const promotionNamesLength = promotionNames.length;
    for (var m = 0; m < promotionNamesLength; m++) {
      const promotionName = promotionNames[m];
      let quantity =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.PROMOTION +
            "_" +
            promotionName +
            "_" +
            payType +
            "_" +
            title.QUANTITY
        ];
      let price =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.PROMOTION +
            "_" +
            promotionName +
            "_" +
            payType +
            "_" +
            title.ITEM_SALES
        ];
      if (quantity === undefined || quantity === NaN) {
        quantity = 0;
      }
      if (price === undefined || price === NaN) {
        price = 0;
      }

      if (quantity !== undefined) {
        values.push({
          name: promotionName,
          val: [Filter.displayNumber(quantity), Filter.displayCurrency(price)],
        });
        totalQty = Number(totalQty) + Number(quantity);
        totalPrice = Number(totalPrice) + Number(price);
      }
    }
    if (values.length <= 0) {
      return (
        <Table2 title={tableTitle} subTitle="(PAID)">
          <tr>
            <td colSpan="3">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: [Filter.displayNumber(totalQty), Filter.displayCurrency(totalPrice)],
    });

    return (
      <Table2 title={tableTitle} subTitle="(PAID)">
        <Row
          styleRow={styleRowTotal}
          name={""}
          values={["Quantity", "Item Sales"]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setMembershipTable = (
    results,
    membershipNames,
    payType,
    tableTitle,
    period
  ) => {
    let values = [];
    let totalQty = 0;
    let totalPrice = 0;
    const membershipNamesLength = membershipNames.length;
    for (var m = 0; m < membershipNamesLength; m++) {
      const membershipName = membershipNames[m];
      let quantity =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.MEMBERSHIP_ID +
            "_" +
            membershipName +
            "_" +
            payType +
            "_" +
            title.QUANTITY
        ];
      let price =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.MEMBERSHIP_ID +
            "_" +
            membershipName +
            "_" +
            payType +
            "_" +
            title.ITEM_SALES
        ];
      if (quantity === undefined || quantity === NaN) {
        quantity = 0;
      }
      if (price === undefined || price === NaN) {
        price = 0;
      }

      if (quantity !== undefined) {
        values.push({
          name: membershipName,
          val: [Filter.displayNumber(quantity), Filter.displayCurrency(price)],
        });
        totalQty = Number(totalQty) + Number(quantity);
        totalPrice = Number(totalPrice) + Number(price);
      }
    }
    if (values.length <= 0) {
      return (
        <Table2 title={tableTitle} subTitle="(PAID)">
          <tr>
            <td colSpan="3">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: [Filter.displayNumber(totalQty), Filter.displayCurrency(totalPrice)],
    });

    return (
      <Table2 title={tableTitle} subTitle="(PAID)">
        <Row
          styleRow={styleRowTotal}
          name={""}
          values={["Quantity", "Item Sales"]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setWaiterTable = (results, waiterNames, payType, tableTitle, period) => {
    let values = [];
    let totalQty = 0;
    let totalPrice = 0;
    const waiterNamesLength = waiterNames.length;
    for (var m = 0; m < waiterNamesLength; m++) {
      const waiterName = waiterNames[m];
      let quantity =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.WAITER +
            "_" +
            waiterName +
            "_" +
            payType +
            "_" +
            title.QUANTITY
        ];
      let price =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.WAITER +
            "_" +
            waiterName +
            "_" +
            payType +
            "_" +
            title.ITEM_SALES
        ];
      if (quantity === undefined || quantity === NaN) {
        quantity = 0;
      }
      if (price === undefined || price === NaN) {
        price = 0;
      }

      if (quantity !== undefined) {
        values.push({
          name: waiterName,
          val: [Filter.displayNumber(quantity), Filter.displayCurrency(price)],
        });
        totalQty = Number(totalQty) + Number(quantity);
        totalPrice = Number(totalPrice) + Number(price);
      }
    }
    if (values.length <= 0) {
      return (
        <Table2 title={tableTitle} subTitle="(PAID)">
          <tr>
            <td colSpan="3">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: [Filter.displayNumber(totalQty), Filter.displayCurrency(totalPrice)],
    });

    return (
      <Table2 title={tableTitle} subTitle="(PAID)">
        <Row
          styleRow={styleRowTotal}
          name={""}
          values={["Quantity", "Item Sales"]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setUnitDiscountTable = (
    results,
    unitDiscountNames,
    payType,
    tableTitle,
    period
  ) => {
    let values = [];
    const unitDiscountNamesLength = unitDiscountNames.length;
    for (var m = 0; m < unitDiscountNamesLength; m++) {
      const unitDiscountName = unitDiscountNames[m];
      const val =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.UNIT_DISCOUNT +
            "_" +
            payType +
            "_" +
            unitDiscountName
        ];
      if (!unitDiscountName || unitDiscountName === "0") {
        continue;
      }
      if (val !== undefined) {
        values.push({
          name: unitDiscountName,
          val: [Filter.displayCurrency(val)],
        });
      }
    }
    var showTotal = 0;
    if (
      results[
        "Total_" +
          title.PERIOD +
          "_" +
          period +
          "_" +
          title.UNIT_DISCOUNT +
          "_" +
          payType
      ] != undefined
    ) {
      showTotal =
        results[
          "Total_" +
            title.PERIOD +
            "_" +
            period +
            "_" +
            title.UNIT_DISCOUNT +
            "_" +
            payType
        ];
    }

    if (showTotal == 0) {
      return (
        <Table2 title={tableTitle} subTitle="(PAID)">
          <tr>
            <td colSpan="2">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: [Filter.displayCurrency(showTotal)],
    });

    return (
      <Table2 title={tableTitle} subTitle="(PAID)">
        <Row
          styleRow={styleRowTotal}
          name={"Name/Per(%)"}
          values={["Discount"]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setBillDiscountTable = (
    results,
    billDiscountNames,
    payType,
    tableTitle,
    period
  ) => {
    let values = [];
    const billDiscountNamesLenth = billDiscountNames.length;
    for (var m = 0; m < billDiscountNamesLenth; m++) {
      const billDiscountName = billDiscountNames[m];
      const val =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            title.BILL_DISCOUNT +
            "_" +
            payType +
            "_" +
            billDiscountName
        ];
      if (!billDiscountName || billDiscountName === "0") {
        continue;
      }
      if (val !== undefined) {
        values.push({
          name: billDiscountName,
          val: [Filter.displayCurrency(val)],
        });
      }
    }
    var showTotal = 0;
    if (
      results[
        "Total_" +
          title.PERIOD +
          "_" +
          period +
          "_" +
          title.BILL_DISCOUNT +
          "_" +
          payType
      ] != undefined
    ) {
      showTotal =
        results[
          "Total_" +
            title.PERIOD +
            "_" +
            period +
            "_" +
            title.BILL_DISCOUNT +
            "_" +
            payType
        ];
    }

    if (showTotal == 0) {
      return (
        <Table2 title={tableTitle} subTitle="(PAID)">
          <tr>
            <td colSpan="2">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: [Filter.displayCurrency(showTotal)],
    });

    return (
      <Table2 title={tableTitle} subTitle="(PAID)">
        <Row
          styleRow={styleRowTotal}
          name={"Name/Per(%)"}
          values={["Discount"]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setWasteTable = (results, wasteItemNames, payType, tableTitle, period) => {
    let values = [];
    const wasteItemNamesLength = wasteItemNames.length;
    for (var m = 0; m < wasteItemNamesLength; m++) {
      const wasteItemName = wasteItemNames[m];
      const val =
        results[
          title.PERIOD +
            "_" +
            period +
            "_" +
            WASTE +
            "_" +
            payType +
            "_" +
            wasteItemName
        ];
      if (!wasteItemName || wasteItemName === "0") {
        continue;
      }
      if (val !== undefined) {
        values.push({
          name: wasteItemName,
          val: [Filter.displayCurrency(val)],
        });
      }
    }
    var showTotal = 0;
    if (
      results[
        "Total_" + title.PERIOD + "_" + period + "_" + WASTE + "_" + payType
      ] != undefined
    ) {
      showTotal =
        results[
          "Total_" + title.PERIOD + "_" + period + "_" + WASTE + "_" + payType
        ];
    }

    if (showTotal == 0) {
      return (
        <Table2 title={tableTitle} subTitle="(PAID)">
          <tr>
            <td colSpan="2">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: [Filter.displayCurrency(showTotal)],
    });

    return (
      <Table2 title={tableTitle} subTitle="(PAID)">
        <Row styleRow={styleRowTotal} name={""} values={["Discount"]}></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  render() {
    let content = <Spinner></Spinner>;

    if (this.state.isNotExist) {
      return <NoData></NoData>;
    }

    if (!this.state.loading && Object.keys(this.state.analysis).length > 0) {
      const analysis = { ...this.state.analysis } || {};

      const periods = [...analysis.periods];
      let controllerNames = { ...analysis.controllerNames } || {};
      const controllers = [...analysis.orderControllerIds] || [];
      const controllersName = [];
      const controllersLength = controllers.length;
      for (let i = 0; i < controllersLength; i++) {
        if (controllerNames[controllers[i]] !== undefined) {
          controllersName.push(controllerNames[controllers[i]]);
        }
      }
      const payTypes = [...analysis.payTypes] || [];
      const totalSummary = { ...analysis.totalSummary } || {};
      const totalSummaryDiscount = { ...analysis.totalSummaryDiscount } || {};
      const statusNames = [...analysis.statusNames] || [];
      const prepareStationNames = [...analysis.prepareStationNames] || [];
      const categoryNames = [...analysis.categoryNames] || [];
      const promotionNames = [...analysis.promotionNames] || [];
      const membershipNames = [...analysis.membershipNames] || [];
      const waiterNames = [...analysis.waiterNames] || [];
      const unitDiscountPercent = [...analysis.unitDiscountPercent] || [];
      const billDiscountPercent = [...analysis.billDiscountPercent] || [];
      const wasteItemNames = [...analysis.wasteItemNames] || [];

      content = null;
      content = periods.map((period, key) => {
        const start = period.range.start;
        const end = period.range.end;
        const description = `FROM ${moment(+start).format("LLL")} TO ${moment(
          +end
        )
          .subtract(1, "minutes")
          .format("LLL")}`;

        const contentChild = payTypes.map((payType, key) => {
          const col1 = (
            <Table title={`Sale ${payType}`}>
              {statusNames.map((status, key) => {
                const val =
                  totalSummary[
                    title.PERIOD +
                      "_" +
                      period.name +
                      "_" +
                      title.STATUS +
                      "_" +
                      status +
                      "_" +
                      payType
                  ];
                return (
                  <Row
                    key={key}
                    styleRow={styleRow}
                    name={"No. of " + status}
                    values={[this.calculateRoundValue(val, 2, false)]}
                  ></Row>
                );
              })}
            </Table>
          );

          const col2 = (
            <div>
              {this.setPrepareStationTable(
                totalSummary,
                prepareStationNames,
                payType,
                "PREPARE STATION",
                period.name
              )}
              {this.setCategoryTable(
                totalSummary,
                categoryNames,
                payType,
                "CATEGORY",
                period.name
              )}
              {this.setPromotionTable(
                totalSummary,
                promotionNames,
                payType,
                "PROMOTION",
                period.name
              )}
              {this.setMembershipTable(
                totalSummary,
                membershipNames,
                payType,
                "MEMBERSHIP ID",
                period.name
              )}
              {this.setWaiterTable(
                totalSummary,
                waiterNames,
                payType,
                "WAITER",
                period.name
              )}
              {this.setUnitDiscountTable(
                totalSummaryDiscount,
                unitDiscountPercent,
                payType,
                "UNIT DISCOUNT",
                period.name
              )}
              {this.setBillDiscountTable(
                totalSummaryDiscount,
                billDiscountPercent,
                payType,
                "BILL DISCOUNT",
                period.name
              )}
              {this.setWasteTable(
                totalSummaryDiscount,
                wasteItemNames,
                payType,
                "WASTAGE",
                period.name
              )}
            </div>
          );

          return (
            <table
              key={key}
              style={{
                width: "100%",
              }}
            >
              <tbody>
                <tr className="desktop hidden-xs hidden-sm">
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "30%",
                    }}
                  >
                    {col1}
                  </Column>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "70%",
                    }}
                  >
                    {col2}
                  </Column>
                </tr>
                <tr className="mobile hidden-md hidden-lg">
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "100%",
                    }}
                  >
                    {col1}
                  </Column>
                </tr>
                <tr className="mobile hidden-md hidden-lg">
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "100%",
                    }}
                  >
                    {col2}
                  </Column>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                {key + 1 !== payTypes.length ? (
                  <tr
                    style={{
                      borderTop: "2px solid black",
                    }}
                  >
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          );
        });

        return (
          <Content
            key={key}
            title="ITEMS SUMMARY"
            description={description}
            controllers={controllersName.join(", ")}
          >
            {contentChild}
          </Content>
        );
      });
    }

    return (
      <div className="ReceptBillSummary">
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <button className="btn btn-primary" onClick={this.exportPdf}>
              <i className="fa fa-print"></i>
              Print
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <div id="exportReceptBill">{content}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default ItemsImportSummary;
